import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

// import p1 from 'assests/Photos/Clubs/HealthWellnessClub/2024/vitmvisit/1.jpg';
// import p2 from 'assests/Photos/Clubs/HealthWellnessClub/2024/vitmvisit/2.jpg';
// import p3 from 'assests/Photos/Clubs/HealthWellnessClub/2024/vitmvisit/3.jpg';
// import p4 from 'assests/Photos/Clubs/HealthWellnessClub/2024/vitmvisit/4.jpg';


import { Typography } from '@mui/material';
import Container from 'components/Container';
import SidebarArticles from 'views/ClassAssembly3E/components/SidebarArticles/SidebarArticles';
import Sidebard2024 from '../HealthAndWellnesClub/Sidebard2024';
import Archive2023 from '../HealthAndWellnesClub/Archive2023';
import HealthClubSidebar2025 from '../HealthClubSidebar2025/HealthClubSidebar2025';

const Dengue2025 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url_2025: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  const p1 = `${config.base_image_url_2025}/home/events-activities/club/HealthWellnessClub/Dengue/1.webp`;
  const p2 = `${config.base_image_url_2025}/home/events-activities/club/HealthWellnessClub/Dengue/2.webp`;
  const p3 = `${config.base_image_url_2025}/home/events-activities/club/HealthWellnessClub/Dengue/3.webp`;
 

  
  const photos = [
    {
      src: p1,
      source: p1,
      rows: 1,
      cols: 1,
    },
    {
        src: p2,
        source: p2,
        rows: 1,
        cols: 1,
      },
      {
        src: p3,
        source: p3,
        rows: 1,
        cols: 1,
      },
    //   {
    //     src: p4,
    //     source: p4,
    //     rows: 1,
    //     cols: 1,
    //   },


    // {
    //   src: 'https://assets.maccarianagency.com/backgrounds/img21.jpg',
    //   source: 'https://assets.maccarianagency.com/backgrounds/img21.jpg',
    //   rows: 1,
    //   cols: 1,
    // },
  ];

  return (
    <Main>
        <Container>
    <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center'>
      Dengue Prevention and Safety Guidelines 
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
     Classes: 8   Date: 06 June 2025
        </Typography>

        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
        A special awareness session on Dengue Prevention and Safety Guidelines was conducted at National Public School on 06 June, 2025. The session was led by Mr Thippeswamy K O, Health Inspector, Nandini Layout Primary Health Care Centre. The primary objective of the session was to educate students and staff about the increasing threat of dengue fever, especially during the monsoon season, and to promote preventive practices.
       <br></br>
       The Health Inspector gave an overview of dengue, its symptoms, and emphasized the importance of awareness and timely action to prevent its spread.
        <br></br>
        It was followed by an interactive Q&A sessions followed, where students actively participated and clarified their doubts. The Health Inspector praised the school’s initiative in promoting public health awareness and encouraged similar efforts in the future.

        </Typography>
      </Box>
      <Typography
          variant={'h4'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
        “One bite can cost a life — act before it strikes.”
<br/>
        </Typography>

      <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 200 : 100}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>
    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <HealthClubSidebar2025/>
             </Box>
             <Box marginBottom={4}>
               <Archive2023/>
             </Box>
         </Grid>
    </Grid> 
    </Container>
    </Main>
   
  );
};

export default Dengue2025;